export const urls = {
  getAllStrategies: () => {
    return `/api/v1/admin/pro/strategy`;
  },
  setStrategiesStatus: () => `/api/v1/admin/pro/strategy`,
};
